import { useTranslation } from "react-i18next";

import { Card, CardActionsHeader, CardTextContent } from "@/components/Card";
import { DragHandle } from "@/components/drag-columns/components/DragItem";
import { GoogleMapPreview } from "@/components/GoogleMapPreview";
import { GoogleMapsLink } from "@/components/GoogleMapsLink";
import { IconButton } from "@/components/IconButton";
import { TextContent } from "@/components/TextContent";

import type { DirectionsWidget } from "./DirectionsCard";

export function StaticDirectionsCard({ widget, onEdit }: { widget: DirectionsWidget; onEdit?: () => void }) {
  const { t } = useTranslation();

  return (
    <Card>
      <DragHandle>
        <CardActionsHeader title={t("event-directions")}>
          {!!onEdit && <IconButton type="button" name="settings" onClick={onEdit} aria-label={t("edit-directions")} />}
        </CardActionsHeader>
      </DragHandle>
      <CardTextContent className="flex flex-col gap-4">
        {!!widget.directions && <TextContent className="min-w-0" content={widget.directions} />}
        {!!widget.place_id && (
          <>
            <GoogleMapPreview placeId={widget.place_id} />
            <GoogleMapsLink placeId={widget.place_id} className="min-w-0 break-all underline" />
          </>
        )}
      </CardTextContent>
    </Card>
  );
}
